import React from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import { convertDDToDMS } from '../../utils';

const Weather = (props) => {
  const { geometry } = props;

  const map = {
    center: [geometry.lat, geometry.lng],
    zoom: 9,
    coordinates: [[geometry.lat, geometry.lng]],
  };

  return (
    <div className="map-wrapper">
      <div className="map">
        <YMaps
          query={{
            ns: 'use-load-option',
            apikey: '31733b63-e752-4a90-bfba-456f2d355a52',
          }}
        >
          <Map state={map} width="100%" height="100%">
            {map.coordinates.map((coordinate) => (
              <Placemark key="coordinates" geometry={coordinate} />
            ))}
          </Map>
        </YMaps>
      </div>

      <ul className="coordinates">
        <li key="1">
          <span data-i18n="map.latitude">Latitude:</span>{' '}
          {convertDDToDMS(props.geometry.lat)}
        </li>
        <li key="2">
          <span data-i18n="map.longitude">Longitude:</span>{' '}
          {convertDDToDMS(props.geometry.lng)}
        </li>
      </ul>
    </div>
  );
};

export default Weather;
